"use strict";

exports.__esModule = true;
exports.UserActionSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _userActionsContext = require("../userActionsContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.name;
}
function renderItemText(input) {
  return input.label;
}
function itemPredicate(query, item) {
  var q = query.toLowerCase();
  return item.name.toLowerCase().indexOf(q) !== -1 || typeof item.description === "string" && item.description.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select userAction(s) from a list.
 */
var UserActionSelector = exports.UserActionSelector = function UserActionSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var userActions = _react["default"].useContext(_userActionsContext.UserActionsContext);
  return /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
    placeholder: props.multiple ? translate("UserActionSelector.placeholder.multiple", "No Actions") : translate("UserActionSelector.placeholder.single", "No Action"),
    width: 250,
    getKey: getKey,
    renderItemText: renderItemText,
    itemPredicate: itemPredicate,
    items: props.items || userActions
  }, props)), props.selected && props.selected.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("UserActionSelector.clearButton.text", "Clear"),
    minimal: true,
    icon: _icons.IconNames.CROSS,
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      return props.onSelect([]);
    }
  }));
};